/* eslint-disable @next/next/no-img-element */
import styled from 'styled-components'

import * as S from '../components/Static.styles'

const defaultProps = {}
const propTypes = {}

const ManagementContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 750px;
  flex-wrap: wrap;
`
const ManagementTitle = styled.h2`
  text-align: center;
  position: relative;
  margin-bottom: 40px;
  &::after {
    background: black;
    content: '';
    display: block;
    height: 3px;
    width: 1em;
    position: absolute;
    left: calc(50% - 0.5em);
    top: 40px;
  }
`

const Manager = styled.div`
  margin: 15px;
`

const ManagerName = styled.h4`
  font-weight: 500;
`
const ManagerPosition = styled.p`
  font-weight: normal;
`

const Banner = styled.img`
  width: 100%;
`

export const componentName = () => {
  return (
    <S.Article id="post-62725">
      <S.Header>
        <S.Title>About TrialSiteNews</S.Title>
      </S.Header>
      <S.Content>
        <div>
          <div>
            <div>
              <picture>
                <source
                  data-srcset="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design.png.webp"
                  type="image/webp"
                  srcSet="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design.png.webp"
                />
                <noscript>
                  <img src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design.png" />
                </noscript>
                <Banner
                  src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design.png"
                  data-src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design.png"
                />
              </picture>
            </div>
          </div>
        </div>
        <p>159 W Broadway, Suite 200 Salt Lake City, UT 84101</p>
        <p>
          TrialSiteNews was launched to drive more interest and awareness in
          clinical research, as well as to develop trust and facilitate
          engagement of researchers and the public. TrialSite started toward the
          end of 2018, financed solely by the{' '}
          <S.MailTo
            href="https://www.linkedin.com/in/oconnordaniel/"
            target="_blank"
            rel="noreferrer noopener"
          >
            founder
          </S.MailTo>
          , to create a new disruptive force in the world of biomedical
          research.
        </p>
        <p>
          TrialSite emphasizes the trial site organization and its staff,
          whether a hospital, health system, community clinic, or commercial
          research center, and the breakthroughs, challenges, best practices,
          and mishaps, all in a bid to provide more transparency for the broader
          population as to the nuts and bolts of clinical trials.
        </p>
        <div style={{ backgroundColor: '#fbf291' }} role="alert">
          <div>
            Have something important to share with our editorial team?{' '}
            <S.MailTo href="mailto:tips@trialsitenews.com">Email us…</S.MailTo>{' '}
            If you need support or have login issues – please use{' '}
            <S.MailTo href="mailto:help@trialsitenews.com">
              help@trialsitenews.com
            </S.MailTo>{' '}
            or the chat (bottom right)
          </div>
        </div>
        <h2>
          <br />
          Mission &amp; Values
        </h2>
        <p>
          TrialSite’s mission is to drive awareness, introduce transparency, and
          facilitate engagement among people all over the world, from
          pharmaceutical professionals and academic researchers to regulators
          and healthcare professionals along with a wide array of the consuming
          public.
        </p>
        <p>
          We value transparency, objectivity, and the scientific method in
          pursuit of the truth wherever it may lead us.
        </p>
        <section id="section-53e57096-9fdf-40bd-8a53-828d79be6e4d">
          <div>
            <div style={{ textAlign: 'center' }}>
              <div>
                <ManagementTitle>Management</ManagementTitle>
              </div>
            </div>
            <ManagementContainer>
              <Manager>
                <div>
                  <div>
                    <div>
                      <div>
                        <picture>
                          <source
                            data-srcset="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-2-1.png.webp"
                            type="image/webp"
                            srcSet="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-2-1.png.webp"
                          />
                          <noscript>
                            <img
                              src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-2-1.png"
                              alt=""
                            />
                          </noscript>
                          <img
                            src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-2-1.png"
                            data-src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-2-1.png"
                            alt=""
                          />
                        </picture>
                      </div>
                    </div>
                    <div>
                      <ManagerName>Daniel O’Connor</ManagerName>
                      <ManagerPosition>Founder / CEO</ManagerPosition>
                    </div>
                  </div>
                </div>
              </Manager>
              <Manager>
                <div>
                  <div>
                    <div>
                      <div>
                        <picture>
                          <source
                            data-srcset="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-4.png.webp"
                            type="image/webp"
                            srcSet="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-4.png.webp"
                          />
                          <noscript>
                            <img
                              src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-4.png"
                              alt=""
                            />
                          </noscript>
                          <img
                            src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-4.png"
                            data-src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-4.png"
                            alt=""
                          />
                        </picture>
                      </div>
                    </div>
                    <div>
                      <ManagerName>Mark Hadfield</ManagerName>
                      <ManagerPosition>Head of Digital</ManagerPosition>
                    </div>
                  </div>
                </div>
              </Manager>
              <Manager>
                <div>
                  <div>
                    <div>
                      <div>
                        <picture>
                          <source
                            data-srcset="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-7.png.webp"
                            type="image/webp"
                            srcSet="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-7.png.webp"
                          />
                          <noscript>
                            <img
                              src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-7.png"
                              alt=""
                            />
                          </noscript>
                          <img
                            src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-7.png"
                            data-src="https://tsnews.wpengine.com/wp-content/uploads/2021/06/Untitled-design-7.png"
                            alt=""
                          />
                        </picture>
                      </div>
                    </div>
                  </div>
                </div>
              </Manager>
            </ManagementContainer>
          </div>
        </section>
        <p />
        <div />
        <span />
      </S.Content>
    </S.Article>
  )
}

componentName.defaultProps = defaultProps
componentName.propTypes = propTypes

export default componentName
